<script>
export default {
  name: 'SummaryDetailOrder',
  props: {
    productsCart: {
      type: Object,
      required: true
    }
  },
  computed: {
    getPriceHt () {
      return (this.getPrice / 1.2).toFixed(2) ?? 0
    },
    getPrice () {
      return this.productsCart.reduce((sum, product) => {
        return sum + product.products.price * product.quantity
      }, 0)
    },
    getTaxe () {
      return (this.getPrice - this.getPriceHt).toFixed(2) ?? 0
    }
  },
}
</script>

<template>
  <div class="space-y-4 bg-gray-50 p-6 dark:bg-gray-800">
    <div class="space-y-2">
      <dl class="flex items-center justify-between gap-4">
        <dt class="font-normal text-gray-500 dark:text-gray-400">Prix original</dt>
        <dd class="font-medium text-gray-900 dark:text-white">
          {{ getPriceHt }}€
        </dd>
      </dl>

      <dl class="flex items-center justify-between gap-4">
        <dt class="font-normal text-gray-500 dark:text-gray-400">
          Taxes
        </dt>
        <dd class="font-medium text-gray-900 dark:text-white">
          {{ getTaxe }}€
        </dd>
      </dl>
    </div>

    <dl class="flex items-center justify-between gap-4 border-t border-gray-200 pt-2 dark:border-gray-700">
      <dt class="text-lg font-bold text-gray-900 dark:text-white">Total</dt>
      <dd class="text-lg font-bold text-gray-900 dark:text-white">
        {{ getPrice }}€
      </dd>
    </dl>
  </div>
</template>

<style scoped>

</style>